var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCross = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.648047,
    y: 0.4,
    width: 31.2,
    height: 31.2,
    rx: 15.6,
    fill: "#252525"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.648047,
    y: 0.4,
    width: 31.2,
    height: 31.2,
    rx: 15.6,
    stroke: "#383838",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4606 21.3069C22.5201 21.3664 22.5672 21.437 22.5994 21.5146C22.6316 21.5923 22.6481 21.6756 22.6481 21.7597C22.6481 21.8438 22.6316 21.927 22.5994 22.0047C22.5672 22.0824 22.5201 22.153 22.4606 22.2125C22.4011 22.2719 22.3306 22.3191 22.2529 22.3513C22.1752 22.3834 22.0919 22.4 22.0078 22.4C21.9237 22.4 21.8405 22.3834 21.7628 22.3513C21.6851 22.3191 21.6145 22.2719 21.555 22.2125L16.2481 16.9048L10.9412 22.2125C10.8212 22.3325 10.6583 22.4 10.4885 22.4C10.3186 22.4 10.1558 22.3325 10.0357 22.2125C9.91561 22.0924 9.84814 21.9295 9.84814 21.7597C9.84814 21.5899 9.91561 21.427 10.0357 21.3069L15.3434 16L10.0357 10.6931C9.91561 10.573 9.84814 10.4101 9.84814 10.2403C9.84814 10.0705 9.91561 9.90763 10.0357 9.78755C10.1558 9.66747 10.3186 9.60001 10.4885 9.60001C10.6583 9.60001 10.8212 9.66747 10.9412 9.78755L16.2481 15.0953L21.555 9.78755C21.6751 9.66747 21.838 9.60001 22.0078 9.60001C22.1776 9.60001 22.3405 9.66747 22.4606 9.78755C22.5807 9.90763 22.6481 10.0705 22.6481 10.2403C22.6481 10.4101 22.5807 10.573 22.4606 10.6931L17.1529 16L22.4606 21.3069Z",
    fill: "#D3D7D9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCross);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cross.4e18dcd8fd1a255aad738e4187421ef9.svg";